export const normalizeTargetingParameter = (str?: string): string => {
  if (!str) return '';

  const letters: Record<string, string> = {
    Ə: 'E',
    Ü: 'U',
    Ö: 'O',
    Ğ: 'Gh',
    Ş: 'Sh',
    Ç: 'Ch',
    İ: 'I',
    ə: 'e',
    ü: 'u',
    ö: 'o',
    ğ: 'gh',
    ş: 'sh',
    ç: 'ch',
    ı: 'i'
  };

  return str
    .replace(/\s*\/\s*|\s*-\/-\s*/g, ' ')
    .split('')
    .map(letter => letters[letter] ?? letter)
    .join('')
    .trim()
    .replace(/\s+/g, '-')
    .replace(/^-+|-+$/g, '');
};
